// Shared normaliser for <input type="date">, which REQUIRES a bare "YYYY-MM-DD" value.
// Backend fields may be date-only OR a full UTC ISO datetime (e.g. "2026-07-28T00:00:00Z");
// assigning the datetime form directly to a date input triggers a browser format warning and
// leaves the field blank. Always pass a value through this before binding it to a date input.
export function toDateInputValue(value) {
  if (!value) return '';
  const text = String(value);
  if (/^\d{4}-\d{2}-\d{2}$/.test(text)) return text;      // already date-only
  const m = text.match(/^(\d{4}-\d{2}-\d{2})T/);           // strip the time/zone from an ISO datetime
  return m ? m[1] : '';
}

export default toDateInputValue;
